import getEnvironment from '../../config/environment';
import useLoggedUser from '../useLoggedUser';
import useStores from '../useStores';

export default function useGeneralData() {
  const { organization } = useLoggedUser();
  const { appStore } = useStores();
  const { envName } = getEnvironment();

  return {
    organization: organization?.name,
    clinicUuid: appStore?.clinicUuid,
    platform2: true,
    env: envName,
  };
}
